"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports["default"] = exports.GiactVerification = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

var _styles = require("@material-ui/core/styles");

var _Alert = _interopRequireDefault(require("../../Alert"));

var _Dialog = _interopRequireDefault(require("../../Dialog"));

var _Gate = _interopRequireDefault(require("../../Gate"));

var _Link = _interopRequireDefault(require("../../Link"));

var _Spacing = _interopRequireDefault(require("../../Spacing"));

var _styles2 = require("../../styles");

var _GiactForm = _interopRequireDefault(require("./GiactForm"));

var _links = require("../../constants/links");

var _i18n = require("../../constants/i18n");

var styles = function styles(theme) {
  var _paper;

  return {
    paper: (_paper = {
      backgroundColor: theme.palette.common.white
    }, (0, _defineProperty2["default"])(_paper, theme.breakpoints.down('xs'), {
      padding: theme.spacing(0, 2, 5)
    }), (0, _defineProperty2["default"])(_paper, theme.breakpoints.only('sm'), {
      padding: theme.spacing(0, 4, 4)
    }), (0, _defineProperty2["default"])(_paper, theme.breakpoints.up('md'), {
      padding: theme.spacing(0, 4, 4),
      minWidth: theme.spacing(68.5)
    }), _paper),
    link: {
      textDecoration: 'none',
      fontWeight: 'bold',
      '&:hover': {
        cursor: 'pointer'
      }
    }
  };
};

exports.styles = styles;
var useStyles = (0, _styles2.makeStyles)(styles);

var GiactVerification = function GiactVerification(_ref) {
  var open = _ref.open,
      onClose = _ref.onClose,
      onSubmit = _ref.onSubmit,
      loading = _ref.loading,
      alertErrorMessage = _ref.alertErrorMessage,
      _ref$showSupportLink = _ref.showSupportLink,
      showSupportLink = _ref$showSupportLink === void 0 ? true : _ref$showSupportLink,
      bankAccountTypeKey = _ref.bankAccountTypeKey,
      bankRoutingNumberKey = _ref.bankRoutingNumberKey,
      bankAccountNumberKey = _ref.bankAccountNumberKey,
      confirmAccountNumberKey = _ref.confirmAccountNumberKey;
  var theme = (0, _styles.useTheme)();
  var classes = useStyles();
  var isMobile = (0, _core.useMediaQuery)(theme.breakpoints.down('xs'));
  return /*#__PURE__*/_react["default"].createElement(_Dialog["default"], {
    open: open,
    onClose: onClose,
    disableEscapeKeyDown: true,
    disableBackdropClick: true,
    maxWidth: isMobile ? 'xs' : 'sm',
    classes: {
      paper: classes.paper
    }
  }, /*#__PURE__*/_react["default"].createElement(_Gate["default"], {
    condition: Boolean(alertErrorMessage)
  }, /*#__PURE__*/_react["default"].createElement(_Spacing["default"], {
    marginBottom: 2
  }, /*#__PURE__*/_react["default"].createElement(_Alert["default"], {
    severity: "error"
  }, alertErrorMessage, /*#__PURE__*/_react["default"].createElement(_Gate["default"], {
    condition: showSupportLink
  }, _i18n.SUPPORT_LINK.text, /*#__PURE__*/_react["default"].createElement(_Link["default"], {
    dataQa: "support-link",
    className: classes.link,
    href: _links.SUPPORT_URL,
    target: "_blank",
    rel: "noopener noreferrer"
  }, _i18n.SUPPORT_LINK.link))))), /*#__PURE__*/_react["default"].createElement(_GiactForm["default"], {
    handleClose: onClose,
    onSubmit: onSubmit,
    loading: loading,
    bankAccountTypeKey: bankAccountTypeKey,
    bankRoutingNumberKey: bankRoutingNumberKey,
    bankAccountNumberKey: bankAccountNumberKey,
    confirmAccountNumberKey: confirmAccountNumberKey
  }));
};

exports.GiactVerification = GiactVerification;
var _default = GiactVerification;
exports["default"] = _default;